import React from 'react';

import {CircularProgress} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import OpportunityCard from "./OpportunityCard";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import withRouter from "../../utils/withRouter";


class OpportunityList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opportunities: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveOpportunities();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveOpportunities();
        }
    }

    async retrieveOpportunities(){
        this.setState({
            opportunities: null
        });
        const url = 'opportunity/';
        const params = {
            page: this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1,
        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        this.setState(
            {
                opportunities: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.opportunities){
            return(
                <CircularProgress/>
            )
        }
        return(
            <CommonPaginatedComponentList
                title={'Проекты'}
                url={'webinar'}
                component={OpportunityCard}
                componentKeyword={'opportunity'}
                data={this.state.opportunities}
                pages={this.state.pages}
                pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
            />
        )
    }
}

export default withRouter(OpportunityList);